import { defineMessages } from 'react-intl';

export const site = defineMessages({
    home: {
        id: 'site.home',
        defaultMessage: 'Home',
    },
});
